export default __webpack_public_path__ + "static/media/Computador v4 abaixo.014b60f4.png";